import {
  queryEditorialStaff,
  queryEditorialStaffIntegration,
} from '@/graphql/wordpress/query/editorial-staff.js'

export default {
  async asyncData({ app, query, error }) {
    try {
      const pageKey = 'editorial-staff'
      const pageItem = app.$configuration.pages.list.find(
        (page) => pageKey === page.key
      )

      if (!pageItem) {
        console.error(`[${pageKey}] doesn't exist in the pages configuration`)
        return error({
          statusCode: 500,
        })
      }

      const requestAuthors = await app.apolloProvider.defaultClient
        .query({
          query: queryEditorialStaff,
          variables: {
            startCursorAuthors: query.prev || null,
            lastAuthors: query.prev ? 10 : null,
            endCursorAuthors: query.next || null,
            firstAuthors: !query.prev ? 10 : null,
            uriPage: pageItem.wpUri,
          },
        })
        .then(({ data }) => data)

      if (!requestAuthors.users) {
        return error({ statusCode: 404 })
      }

      const page = requestAuthors

      return {
        page,
        pageItem,
      }
    } catch (e) {
      console.error(e)
      // return error({ statusCode: 500 })
    }
  },
  computed: {
    seo() {
      const seo = this.$generateTags(
        {
          ...this.page.pageBy.seo,
        },
        this.$i18n
      )
      return seo
    },
  },
  methods: {
    async integrateQuery() {
      try {
        //  Dato che le query sono lente integro i dati del post con una query client side richiamando gli ADV e la descrizione che sono le parti più onerose per la query
        const requestEditorialStaffIntegration = await this.$apollo
          .query({
            query: queryEditorialStaffIntegration,
            variables: {
              uriPage: this.pageItem.wpUri,

              startCursorAuthors: this.$route.query.prev || null,
              lastAuthors: this.$route.query.prev ? 10 : null,
              endCursorAuthors: this.$route.query.next || null,
              firstAuthors: !this.$route.query.prev ? 10 : null,
            },
          })
          .then(({ data }) => data)

        // Assegno gli ADV
        /* this.page.pageBy = {
          ...this.page.pageBy,
          advertising: requestEditorialStaffIntegration.pageBy.advertising,
        } */
        this.page = requestEditorialStaffIntegration
      } catch (e) {
        console.error(e)
        // return this.$nuxt.context.error({ statusCode: 500 })
      }
    },
  },
  async mounted() {
    await this.integrateQuery()
  },
  async updated() {
    if (!this.page.pageBy.advertising) await this.integrateQuery()
  },
  watchQuery: ['prev', 'next'],
}
